// extracted by mini-css-extract-plugin
export default {"header":"ProjectInfo_header__QM3PD","tableContainer":"ProjectInfo_tableContainer__sLi+n"};